import type { HttpClient } from '@store/base';
import queryString from 'query-string';
import { GetGoodsCategoryRequest, GetGoodsCategoryResponse } from '../../model';

export class GetGoodsCategoryGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsCategoryRequest) {
    const query = queryString.stringify(req);

    return await this.httpClient.request<GetGoodsCategoryResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/content-info-service/api/v1/categories/hs-mall/cascade?${query}`,
    });
  }
}
